import { getFunction } from '@nucleus/lib-function';
import { objectKeys } from '@nucleus/lib-shape';
import { filterNotUndefined } from '@nucleus/src-platform/data';
import React, { createContext } from 'react';

type WebFontDefinition = Record<string, any>;

const DefaultGoogleFontApi = 'https://fonts.googleapis.com/css';

export class ServerFontCollector {
  private api: string;
  private definitions: WebFontDefinition;

  constructor({ api = DefaultGoogleFontApi }: { api?: string } = {}) {
    this.api = api;
    this.definitions = {};
  }

  setDefinitions(definitions: WebFontDefinition): void {
    this.definitions = definitions;
  }

  getFontUrls(): Array<string> {
    // TODO: find a way to use `webfontloader` to generate urls... currently not exported from the package
    const getGoogleFontUrl = (families: Array<string>) => {
      if (families.length === 0) {
        return;
      }

      const googleSafe = (value: string) => value.replace(/ /g, '+');

      const fontImport = this.definitions.google.families.map(googleSafe).join('%7C');

      return `${this.api}?family=${fontImport}`;
    };

    const fontLinkMap = {
      google: getGoogleFontUrl,
    };

    const tags = objectKeys(this.definitions).map((key) => getFunction(fontLinkMap, key)(this.definitions[key]));

    return filterNotUndefined(tags);
  }
}

export const ServerFontContext = createContext<ServerFontCollector | null>(null);

export const ServerFontProvider = (props: {
  children?: React.ReactNode;
  fontCollector: ServerFontCollector;
}): JSX.Element => {
  return <ServerFontContext.Provider value={props.fontCollector}>{props.children}</ServerFontContext.Provider>;
};
